import {DataTableTranslations} from'./data-table-translations.type'

export const defaultTranslations: DataTableTranslations = {
	headerReload: 'reload',
	headerColumnSelector: 'column selector',
	indexColumn: 'index',
	selectColumn: 'select',
	selectRow: 'select',
	selectAllRows: 'select',
	expandColumn: 'expand',
	expandRow: 'expand',
	paginationLimit: 'Limit',
	paginationRange: 'Results'
};



// WEBPACK FOOTER //
// ./~/angular-4-data-table/src/types/default-translations.type.ts